import { FC, useEffect, useState, Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogTitle, Typography, TextField, DialogActions, CircularProgress, IconButton, Button, Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
interface Props {
  onClose?: () => void;
  onDeleteFile?: () => any;
  filename?: string;
  fileCount?: number;
  isLoadingDelete?: boolean;
}
export const DeleteFileModal: FC<Props> = ({
  onClose,
  onDeleteFile,
  filename,
  fileCount,
  isLoadingDelete
}) => {
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  return <Dialog open={true} fullWidth maxWidth={"xs"} onClose={onClose} data-sentry-element="Dialog" data-sentry-component="DeleteFileModal" data-sentry-source-file="DeleteFileModal.tsx">
      <DialogTitle component="div" data-sentry-element="DialogTitle" data-sentry-source-file="DeleteFileModal.tsx">
        <Box sx={{
        backgroundColor: "red.100",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }} data-sentry-element="Box" data-sentry-source-file="DeleteFileModal.tsx">
          <DeleteRoundedIcon sx={{
          color: "red.600"
        }} data-sentry-element="DeleteRoundedIcon" data-sentry-source-file="DeleteFileModal.tsx" />
        </Box>
        <Typography variant="h5" fontWeight={700} sx={{
        mt: 2
      }} data-sentry-element="Typography" data-sentry-source-file="DeleteFileModal.tsx">
          {fileCount > 1 ? t("media.deleteFileModalTitleMultiple", {
          count: fileCount
        }) : t("media.deleteFileModalTitleSingle")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="DeleteFileModal.tsx">
        <Typography sx={{
        wordBreak: "break-all"
      }} data-sentry-element="Typography" data-sentry-source-file="DeleteFileModal.tsx">
          {fileCount > 1 ? t("media.deleteFileModalWarningMultiple") : t("media.deleteFileModalWarningSingle", {
          filename
        })}
        </Typography>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="DeleteFileModal.tsx">
        <Button color="inherit" disabled={isLoadingDelete} onClick={() => onClose()} data-sentry-element="Button" data-sentry-source-file="DeleteFileModal.tsx">
          {t("common.cancel")}
        </Button>
        <Button variant="contained" color="error" aria-label={t("media.deleteFileModalDeleteButtonAria")} onClick={() => onDeleteFile()} disabled={isLoadingDelete} data-sentry-element="Button" data-sentry-source-file="DeleteFileModal.tsx">
          {isLoadingDelete ? <CircularProgress size="24px" color="inherit" /> : <>
              {fileCount > 1 ? t("media.deleteFileModalDeleteButtonMultiple", {
            count: fileCount
          }) : t("common.delete")}
            </>}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default DeleteFileModal;